import * as Types from '../../../../../../generated/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCoaSessionQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetCoaSessionQuery = { __typename?: 'Query', coaSession?: { __typename?: 'CoaSession', id?: string | null, claimId?: string | null, mileage?: number | null, damagedParts?: Array<string | null> | null, pointsOfImpact?: Array<string | null> | null, completedAt?: string | null, vin?: string | null, additionalPhotos?: Array<{ __typename?: 'CoaPhotos', format?: string | null, path?: string | null, key?: string | null, bucket?: string | null } | null> | null, digitalJourney?: { __typename?: 'DigitalJourney', firstNamePh?: string | null, lastNamePh?: string | null, phoneNumberPh?: string | null, emailPh?: string | null, licensePlatePh?: string | null, accidentDateTime?: string | null, accidentLocationId?: number | null, accidentType?: Types.AccidentType | null, vandalismSeverity?: Types.VandalismSeverity | null, naturalEventType?: Types.NaturalEventType | null, insuranceType?: Types.InsuranceType | null, numInjuredPeople?: number | null, driverPresent?: boolean | null, informationOnOtherDriver?: boolean | null, additionalDetails?: string | null, numVehiclesInvolved?: number | null, informationOnOtherVehicle?: boolean | null, claimHandlingDecision?: Types.ClaimHandlingDecision | null, bodyShopId?: number | null, cai?: Types.CaiEnum | null, authoritiesIntervention?: Types.AuthoritiesIntervention | null, accidentResponsibility?: Types.AccidentResponsibility | null, vehicleTypePh?: Types.VehicleType | null, pointsOfImpactPh?: Array<string | null> | null, mileage?: number | null, airbagDeployed?: boolean | null, isDrivable?: boolean | null, pointsOfImpactGlass?: Array<Types.PointOfImpactGlass | null> | null, vehicleCircumstancePh?: Types.Circumstance | null, personalCodePh?: string | null, postalCode?: string | null, otherDriverFirstName?: string | null, otherDriverLastName?: string | null, otherDriverPersonalCode?: string | null, otherVehicleInsurance?: string | null, otherVehicleLicensePlate?: string | null, otherVehiclePointsOfImpact?: Array<string | null> | null, otherVehicleCircumstance?: Types.Circumstance | null, otherVehicleType?: Types.VehicleType | null, accidentLocation?: { __typename?: 'DigitalJourneyAccidentLocation', city?: string | null, postalCode?: string | null, province?: string | null, country?: string | null } | null, bodyShop?: { __typename?: 'DigitalJourneyBodyShop', id?: number | null, name?: string | null, region?: string | null, province?: string | null, city?: string | null, address?: string | null, postalCode?: string | null, phoneNumber?: string | null, email?: string | null, vatNumber?: string | null } | null, caiPhotos?: Array<{ __typename?: 'Image', id?: string | null, path?: string | null } | null> | null, hospitalReportPhotos?: Array<{ __typename?: 'Image', id?: string | null, path?: string | null } | null> | null, authoritiesPhotos?: Array<{ __typename?: 'Image', id?: string | null, path?: string | null } | null> | null, pdfS3Location?: string | null, postalCodePh?: string | null, injuredPersons?: Array<{ __typename?: 'InjuredPerson', firstName?: string | null, lastName?: string | null, personalCode?: string | null, role?: Types.InjuredRole | null } | null> | null } | null } | null };


export const GetCoaSessionDocument = gql`
    query getCoaSession($id: String) {
  coaSession(id: $id) {
    id
    claimId
    mileage
    damagedParts
    pointsOfImpact
    completedAt
    vin
    additionalPhotos {
      format
      path
      key
      bucket
    }
    digitalJourney {
      firstNamePh
      lastNamePh
      phoneNumberPh
      emailPh
      licensePlatePh
      accidentDateTime
      accidentLocationId
      accidentLocation {
        city
        postalCode
        province
        country
      }
      accidentType
      vandalismSeverity
      naturalEventType
      insuranceType
      numInjuredPeople
      driverPresent
      informationOnOtherDriver
      additionalDetails
      numVehiclesInvolved
      informationOnOtherVehicle
      claimHandlingDecision
      bodyShopId
      bodyShop {
        id
        name
        region
        province
        city
        address
        postalCode
        phoneNumber
        email
        vatNumber
      }
      cai
      authoritiesIntervention
      accidentResponsibility
      caiPhotos {
        id
        path
      }
      hospitalReportPhotos {
        id
        path
      }
      authoritiesPhotos {
        id
        path
      }
      vehicleTypePh
      pointsOfImpactPh
      mileage
      airbagDeployed
      isDrivable
      pointsOfImpactGlass
      vehicleCircumstancePh
      personalCodePh
      postalCodePh
      otherDriverFirstName
      otherDriverLastName
      otherDriverPersonalCode
      otherVehicleInsurance
      otherVehicleLicensePlate
      otherVehiclePointsOfImpact
      otherVehicleCircumstance
      otherVehicleType
      injuredPersons {
        firstName
        lastName
        personalCode
        role
      }
      pdfS3Location
    }
  }
}
    `;

/**
 * __useGetCoaSessionQuery__
 *
 * To run a query within a React component, call `useGetCoaSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoaSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoaSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoaSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetCoaSessionQuery, GetCoaSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoaSessionQuery, GetCoaSessionQueryVariables>(GetCoaSessionDocument, options);
      }
export function useGetCoaSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoaSessionQuery, GetCoaSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoaSessionQuery, GetCoaSessionQueryVariables>(GetCoaSessionDocument, options);
        }
export type GetCoaSessionQueryHookResult = ReturnType<typeof useGetCoaSessionQuery>;
export type GetCoaSessionLazyQueryHookResult = ReturnType<typeof useGetCoaSessionLazyQuery>;
export type GetCoaSessionQueryResult = Apollo.QueryResult<GetCoaSessionQuery, GetCoaSessionQueryVariables>;